export const TabListGroup = [
    { key: "1", label: "Users" },
    { key: "2", label: "Courses / Curriculums" },
  ];

 export  const GroupReportTableTab = [
    { key: "1", label: "Active Groups" },
    { key: "2", label: "Inactive Groups" },
  ];

 export const tabListCourses = [
    { key: "1", label: "Active Courses" },
    { key: "2", label: "Inactive Courses" },
  ];
